<template>
  <div v-if="shop" >
    <cg-shop-header :menu-sections="sections" ></cg-shop-header>


    <div v-if="loadingShop" class="flex items-center">
      <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
        <cg-loader :show="true"></cg-loader>
      </div>
    </div>

    <section class="container mt-9x p-0" id="welcome">
      <div v-if="shop.info" class="w-full flex lg:flex-row md:flex-col sm:flex-col lg:mt-3x">
        <div v-if="shop.info.welcome" class="lg:pr-6">
          <div v-if="shop.info.welcome.title" v-html="shop.info.welcome.title" class="mt-0 mb-1x"></div>
          <div v-if="shop.info.welcome.sub_title" v-html="shop.info.welcome.sub_title" class="mb-3x sm:mb-2x font-normal justify-start text-left"></div>
          <p v-if="shop.info.welcome.description" v-html="shop.info.welcome.description" class="mb-2x"></p>
          <a v-if="shop.url" :href="shop.url">
            <button class="btn icon black outline">
              <span><icon class="icon" name="chevron-right"></icon></span><span>Webseite besuchen</span>
            </button>
          </a>
        </div>
        <image-slider :images="shop.shopImages.data"></image-slider>
      </div>
    </section>

    <section id="news">

    </section>

    <section id="products">
        <productlist :shop="shop" :products="productList" :title="'Unsere beliebtesten Produkte'" :type="'teaser'"></productlist>
    </section>

    <section class="container" id="more" v-if="shop.info && shop.info.about">
      <div class="flex mb-4 flex-wrap">
        <div class="w-full text-center">
          <div v-if="shop.info.about.title" v-html="shop.info.about.title" class="mb-1x"></div>
          <div v-if="shop.info.about.sub_title" v-html="shop.info.about.sub_title" class="mb-3x sm:mb-2x"></div>
          <p v-if="shop.info.about.description" v-html="shop.info.about.description" class="mb-2x"></p>
        </div>
      </div>

      <shop-slider v-if="similarShops.data.length" :shops="similarShops" title="Das könnte Dich auch interessieren"></shop-slider>
    </section>
    <cgfooter></cgfooter>
  </div>
</template>

<script>
  import CgShopHeader from '../components/shop/CgShopHeader'
  import Productlist from '../components/ProductList'
  import {mapGetters, mapActions} from 'vuex'
  import ImageTextSlider from '../components/slider/imageTextSlider'
  import ImageSlider from '../components/slider/imageSlider'
  import ShopSlider from '../components/slider/shopSlider'
  import Cgfooter from '../components/CgFooter'
  import CgLoader from '../components/menus/cgLoader'

  export default {
    name: 'shop-details',
    components: {
      Cgfooter,
      CgLoader,
      ShopSlider,
      ImageTextSlider,
      ImageSlider,
      Productlist,
      CgShopHeader
    },
    data () {
      return {
        sections: {
          'welcome': 'Willkommen',
          'products': 'Beliebte Produkte',
          'more': 'Weitere Informationen'
        },
        hideFromRecommended: {},
        loadingShop: true
      }
    },
    beforeRouteUpdate (to, from, next) {
      next()
      this.init()
    },
    created () {
      this.init()
    },
    methods: {
      ...mapActions([
        'getShopProductTeaserList',
        'getShopDetails',
        'getShopTeaserList'
      ]),
      init () {
        this.loadingShop = true
        this.shopUid = this.$route.params.id
        this.hideFromRecommended[this.shopUid] = true
        var self = this
        this.getShopDetails({
          uid: this.shopUid,
          cb () {
            self.loadingShop = false
          },
          errorCb () {
            self.loadingShop = false
          }
        })
        this.getShopProductTeaserList({shop: this.shopUid})
        this.getShopTeaserList({shop: this.shopUid})
      }
    },
    computed: {
      ...mapGetters({
        productList: 'shop_get_product_list',
        shop: 'shop_get_details',
        similarShops: 'shop_get_teaser_list'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Shop.vue